<template>
  <div class="row">
    <div class="col-md-9">
      <ConsumptionBox class="v-step-0" />
      <SubscriptionBox class="v-step-3" />
      <HomeSimBox class="v-step-4" />
      <MobileMoneyBox v-if="false" />
    </div>

    <div id="home_side_bar" class="col-md-3">
      <InfoSimWidget class="v-step-1" />
      <OtherSimWidget class="v-step-2" />
      <v-tour
        name="home-tour"
        :steps="steps"
        :options="tour_options"
        :callbacks="myCallbacks"
      ></v-tour>
    </div>
  </div>
</template>
<script>
import ConsumptionBox from "@/components/home/ConsumptionBox";
import SubscriptionBox from "@/components/home/SubscriptionBox";
import InfoSimWidget from "@/components/home/InfoSimWidget";
import OtherSimWidget from "@/components/home/OtherSimWidget";
import HomeSimBox from "@/components/home/HomeSimBox";
import MobileMoneyBox from "@/components/home/MobileMoneyBox.vue";

export default {
  components: {
    ConsumptionBox,
    SubscriptionBox,
    InfoSimWidget,
    OtherSimWidget,
    HomeSimBox,
    MobileMoneyBox,
  },
  name: "Home",
  data() {
    return {
      guided_tour: "",
      steps: [],
      tour_options: {
        useKeyboardNavigation: false,
        labels: {
          buttonSkip: "Passer",
          buttonPrevious: "Précédent",
          buttonNext: "Suivant",
          buttonStop: "Suivant",
        },
      },
      myCallbacks: {
        onPreviousStep: this.myCustomPreviousStepCallback,
        onNextStep: this.myCustomNextStepCallback,
        onFinish: this.onFinish,
        onSkip: this.onSkip,
      },
    };
  },
  created: function () {
    this.guided_tour = this.$store.state.configs.guided_tour;
    if (this.guided_tour !== {}) {
      this.steps = this.guided_tour.home.steps;
      this.steps = this.steps.map((element, index) => {
        return {
          target: `.v-step-${index}`,
          content: element.content,
          params: {
            placement: "bottom",
          },
        };
      });
    }
  },
  mounted() {
    if (
      this.steps.length > 0 &&
      this.$store.state.core.first_login_configs.already_guided == false
    ) {
      this.$tours["home-tour"].start();
    }
  },
  methods: {
    myCustomPreviousStepCallback(currentStep) {},
    myCustomNextStepCallback(currentStep) {},
    onFinish() {
      if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "sim-card" });
      }
    },
    onSkip() {
      if (this.$store.state.core.first_login_configs.already_guided == false) {
        this.$router.push({ name: "sim-card" });
      }
    },
  },
};
</script>
<style scoped lang="css">
</style>
